import React, { Component } from 'react';
import DownloadFile from './../../../commons/DownloadFile.js';
import FileUploaderBlob from '../../../commons/FileUploaderBlob.js';

export default class ProductAllocation extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Product Allocation
					</div>
					<div>
						<DownloadFile title="Download Product Allocation Dump" url="dump/space/product/allocation"/>
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="ingest/space/product/mapping"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/SpaceOperations/Components/ProductAllocation.js